import React, {useState, useEffect} from 'react';
import SMCModal from '../../../components/core/SMCModal';
import {useTranslation} from 'react-i18next';
import ImportDomainSMPStepOne from './ImportDomainSMPStepOne';
import ImportDomainSMPStepTwo from './ImportDomainSMPStepTwo';

export const CertificateHandlingValues = {
    retain: 'retain',
    import: 'import',
    revoke: 'revoke'
};

function ImportDomainSMPModal({
    isOpen = false,
    onRequestClose
}) {
    const { t } = useTranslation();

    const [editorStep, setEditorStep] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');
    
    const [fileToImport, setFileToImport] = useState(null);


    const pageParams = {
        fileToImport, setFileToImport,
    };

    // Reset all values on open
    useEffect(() => {
        if (isOpen) {
            setEditorStep(0);
            setErrorMessage('');
            setFileToImport(null);
       
        }
    }, [isOpen]);

    const onFinish = () => { }

    let EditorBody = () => null;

    switch (editorStep) {
        case 0:
            EditorBody = ImportDomainSMPStepOne;
            break;
        case 1:
            EditorBody = ImportDomainSMPStepTwo;
            break;
        default:
            onRequestClose();
            break;
    }

    return (
        <SMCModal
            isOpen={isOpen}
            width={710}
            height={455}
            title={t('SMC_SYSOPS_IMPWIZ_TITLE')}
            onRequestClose={onRequestClose}
            hasError={!!errorMessage}
            errorMessage={errorMessage}
        >
            <EditorBody
                onCancel={onRequestClose}
                onNext={() => setEditorStep(step => step+1)}
                onBack={() => setEditorStep(step => step-1)}
                onFinish={onFinish}
                pageParams={pageParams}
            />
        </SMCModal>

    );
}

export default ImportDomainSMPModal;